import { reportsPerSection } from '@/src/utils/rolesConst';
import { CompanySource } from '../../../../Interfaces/admin/User.interfaces';

export const INSURANCE_OPTIONS = [
  {
    label: 'Insurance Dashboard',
    url: '/insurance',
    companySources: [CompanySource.ViewPoint, CompanySource.Yardi],
  },
  {
    label: 'Policies',
    url: 'policies',
    companySources: [CompanySource.ViewPoint, CompanySource.Yardi],
    reports: reportsPerSection['policy'],
  },
  {
    label: 'Claims',
    url: 'claims',
    companySources: [CompanySource.ViewPoint, CompanySource.Yardi],
    reports: reportsPerSection['claim'],
  },
  {
    label: 'New',
    url: 'new',
    style: 'highlightOption p-2 text-white border-round-lg',
    reports: reportsPerSection['insurance_new'],
    companySources: [CompanySource.ViewPoint, CompanySource.Yardi],
  },
];
